import { useEffect } from 'react';
import { Trophy, Home } from 'lucide-react';
import { submitLead } from '@/utils/api';
import { CONSULTANT_NAME } from '@/constants';

export default function QuizResult({ score, answers, leadData, onReset }) {
  useEffect(() => {
    // Fire-and-forget lead submission
    submitLead({
      type: 'quiz',
      name: leadData.name,
      phone: leadData.phone,
      email: leadData.email,
      score,
      answers,
      timestamp: new Date().toISOString(),
    }).catch(() => {});
  }, []);

  return (
    <div className="px-6 py-8 text-center animate-fade-in" data-testid="quiz-result-screen">
      {/* Trophy Icon */}
      <div
        className="mx-auto mb-6 w-20 h-20 rounded-full flex items-center justify-center animate-pulse-gold"
        style={{
          background: 'rgba(76, 175, 80, 0.15)',
          border: '2px solid #4CAF50',
        }}
        data-testid="quiz-result-icon"
      >
        <Trophy
          size={36}
          strokeWidth={1.5}
          style={{ color: '#4CAF50' }}
        />
      </div>

      {/* Score */}
      <h2
        className="font-headline text-2xl sm:text-3xl mb-3 text-white"
        data-testid="quiz-result-score"
      >
        Acertou {score} de 5!
      </h2>

      {/* Confirmation message */}
      <div className="mb-8 animate-fade-in-up" style={{ opacity: 0, animationDelay: '200ms' }}>
        <div
          className="rounded-xl p-5 mb-4"
          style={{
            background: 'rgba(76, 175, 80, 0.1)',
            border: '1px solid rgba(76, 175, 80, 0.2)',
          }}
          data-testid="quiz-result-prize"
        >
          <p className="font-headline text-base mb-2" style={{ color: '#4CAF50' }}>
            Participação confirmada!
          </p>
          <p className="font-body text-sm text-white leading-relaxed">
            Está inscrito no{' '}
            <strong style={{ color: '#B5985A' }}>sorteio trimestral de uma volta de kart</strong>{' '}
            no Kartódromo Internacional de Palmela.
          </p>
          <p className="font-body text-xs mt-3" style={{ color: '#A3A3A3' }}>
            O vencedor será anunciado no final do trimestre. O {CONSULTANT_NAME} entrará em contacto com o sorteado.
          </p>
        </div>
      </div>

      {/* Back Button */}
      <button
        onClick={onReset}
        className="btn-outline w-full"
        data-testid="quiz-result-back-btn"
      >
        <Home size={18} strokeWidth={1.5} />
        Voltar ao início
      </button>
    </div>
  );
}
